export default "__VITE_ASSET__foxVAGdB__"